export default __webpack_public_path__ + "static/media/registerFalse.205237aa.png";